export default __webpack_public_path__ + "static/media/link-dark.ccc74efc.svg";